import React from 'react';
import { useCropStore } from '../store/cropStore';

interface CropPreviewProps {
  imageUrl?: string;
}

export const CropPreview: React.FC<CropPreviewProps> = ({ imageUrl }) => {
  const { croppedArea, aspectRatioValue } = useCropStore();

  if (!imageUrl || !croppedArea || !aspectRatioValue) {
    return null;
  }

  const scale = 100 / croppedArea.width;
  const transform = {
    x: `${-croppedArea.x * scale}%`,
    y: `${-croppedArea.y * scale}%`,
    scale,
    width: 'calc(100% + 0.5px)',
    height: 'auto',
  };

  const imageStyle = {
    transform: `translate3d(${transform.x}, ${transform.y}, 0) scale3d(${transform.scale},${transform.scale},1)`,
    width: transform.width,
    height: transform.height,
    transformOrigin: 'top left',
  };

  return (
    <div className="absolute bottom-4 right-4 w-32 bg-gray-900 rounded-lg shadow-xl border border-gray-700 overflow-hidden">
      <div className="relative" style={{ paddingBottom: `${100 / aspectRatioValue}%` }}>
        <img src={imageUrl} alt="" style={imageStyle} className="absolute inset-0" />
      </div>
    </div>
  );
};
